<template>
  <v-select
    ref="select"
    :label="label"
    :items="countryItems"
    item-text="name"
    :item-value="countryValue"
    multiple
    return-object
    small-chips
    v-model="selectedCountries"
    v-bind:value="value"
    v-on:input="onInputChanged"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="allCountriesSelected && index === 0">
        <span>{{ labelAllCountries }}</span>
      </v-chip>
      <v-chip v-if="!allCountriesSelected && index === 0">
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-if="!allCountriesSelected && index === 1" class="grey--text text-caption">
        (+{{ selectedCountries.length - 1 }} {{ labelCountries }})
      </span>
    </template>

    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> {{ labelSelectAllCountries }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: Array,
    label: String,
    labelCountries: String,
    labelAllCountries: String,
    labelSelectAllCountries: String,
    countries: Array,
    countryValue: { type: String, default: 'id' },
    required: Boolean,
  },

  data() {
    return {
      countryItems: [],
      selectedCountries: [],
    };
  },

  watch: {
    value: {
      handler: function (newValue) {
        this.selectedCountries = newValue || [];
      },
      immediate: true,
    },
    countries: {
      handler: function (newList) {
        if (!newList) return;
        const sweden = newList.find((country) => country.cca3 === 'SWE');
        const nordicCountries = newList.filter((country) => country.isNordic && country.cca3 !== 'SWE');
        const restOfTheWorld = newList.filter((country) => !country.isNordic);
        this.countryItems = [sweden, ...nordicCountries, { id: -1, name: '', divider: true }, ...restOfTheWorld];
      },
      immediate: true,
    },
  },

  // För att kunna använda denna komponent i en form och validera den
  inject: {
    form: { default: null },
  },
  created() {
    this.form && this.form.register(this);
  },
  beforeDestroy() {
    this.form && this.form.unregister(this);
  },

  computed: {
    countriesWithoutDivider() {
      return this.countryItems.filter((item) => !item?.divider);
    },
    someCountriesSelected() {
      return this.selectedCountries.length > 0 && this.selectedCountries.length < this.countriesWithoutDivider.length;
    },
    allCountriesSelected() {
      return this.selectedCountries.length === this.countriesWithoutDivider.length;
    },
    icon() {
      if (this.allCountriesSelected) return 'mdi-close-box';
      if (this.someCountriesSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    hasError() {
      return this.required && this.selectedCountries?.length === 0;
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.allCountriesSelected) {
          this.selectedCountries = [];
        } else {
          this.selectedCountries = [...this.countriesWithoutDivider];
        }
        this.onInputChanged();
      });
    },

    onInputChanged() {
      this.$emit('input', this.selectedCountries);
    },

    // Used by the form to reset validation on the field
    resetValidation() {
      this.$refs.select.resetValidation();
    },
    reset() {
      this.$refs.select.reset();
    },
  },
};
</script>
